import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    isFetching: false,
};

const fetchData = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.SET_FETCHING_DATA:
        return { ...state, isFetching: action.payload };
    default:
        return state;
    }
};

export default fetchData;



/** WEBPACK FOOTER **
 ** ./src/reducers/fetch-data.js
 **/